import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vip-discounts-container',
  templateUrl: './vip-discounts-container.component.html',
  styleUrls: ['./vip-discounts-container.component.scss'],
})
export class VipDiscountsContainerComponent implements OnInit, OnDestroy {
  subs = new Subscription();
  activeLinkIndex = -1;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.navigate(this.router.url);
    this.subs = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.navigate(e.urlAfterRedirects);
      }
    });
  }

  navigate(url: string): void {
    if (url.endsWith(`/products-and-partners`)) {
      this.activeLinkIndex = 0;
    } else if (url.endsWith(`/given`)) {
      this.activeLinkIndex = 1;
    } else {
      this.router.navigate([
        '/selling/prices/discounts/vip-discounts/products-and-partners',
      ]);
    }
  }

  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
}
